howspace.widgets.onEvent('discussion:demo:finished', (widget, notification) => {
    real.notification.show(howspace.translate('discussion_demo_finished'), 'info', true);
});
